import React, { useState, useContext } from "react";
import { makeStyles } from "@mui/styles";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import "./filterStyles.css";
import * as styles from "./DatePicker.module.scss";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { useTranslation } from "react-i18next";
import DomainContext from "../../context/DomainContext";
import deLocale from "date-fns/locale/de";
import enLocale from "date-fns/locale/en-US";
import { Modal, Box, TextField, Typography, Button } from "@mui/material";

const BasicDateRangePicker = (props) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [isSelectingStart, setIsSelectingStart] = useState(true);

  const domain = useContext(DomainContext);
  const { t } = useTranslation();
  
  const useStyles = makeStyles({
    root: {
      "& .MuiDialogActions-root": {
        background: "red!important",
      },
    },
  });
  const classes = useStyles();
  const { changeDateRange, lightCalendar } = props;
  
  const handleDateChange = (date) => {
    if (isSelectingStart) {
      setStartDate(date);
      setIsSelectingStart(false);
    } else {
      setEndDate(date);
      if (startDate && date) {
        changeDateRange([startDate, date]);
        setOpenCalendar(false);
        setIsSelectingStart(true);
      }
    }
  };

  const handleClose = () => {
    setOpenCalendar(false);
    setIsSelectingStart(true);
  };

  return (
    <div className={styles.calendarContainer}>
      <CalendarTodayIcon
        className={`${styles.calendarIcon} ${
          lightCalendar ? styles.active : null
        }`}
        onClick={() => {
          if (lightCalendar === false) {
            setStartDate(null);
            setEndDate(null);
          }
          setOpenCalendar(true);
        }}
      />
      <Modal
        open={openCalendar}
        onClose={handleClose}
        aria-labelledby="date-range-picker-modal"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          minWidth: 300,
        }}>
          <Typography variant="h6" component="h2" mb={2}>
            {isSelectingStart ? (t ? t("Start Date") : "Start Date") : (t ? t("End Date") : "End Date")}
          </Typography>
          <LocalizationProvider 
            dateAdapter={AdapterDateFns} 
            adapterLocale={domain === "en" ? enLocale : deLocale}
          >
            <DatePicker
              value={isSelectingStart ? startDate : endDate}
              onChange={handleDateChange}
              slots={{
                textField: TextField,
              }}
              slotProps={{
                textField: { fullWidth: true }
              }}
            />
          </LocalizationProvider>
          <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
            <Button onClick={handleClose} variant="outlined">
              {t ? t("Cancel") : "Cancel"}
            </Button>
            {startDate && endDate && (
              <Button 
                onClick={() => {
                  changeDateRange([startDate, endDate]);
                  setOpenCalendar(false);
                }} 
                variant="contained"
              >
                {t ? t("Apply") : "Apply"}
              </Button>
            )}
          </Box>
          {startDate && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {t ? t("Start") : "Start"}: {startDate.toLocaleDateString()}
              {endDate && ` - ${t ? t("End") : "End"}: ${endDate.toLocaleDateString()}`}
            </Typography>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default BasicDateRangePicker;